// extracted by mini-css-extract-plugin
module.exports = {"tourismgiverny":"tourismGivernyPage_tourismgiverny__w_Pl9"};